/**
 * Secure OIDC redirect handler
 * Backend generates the authorization URL (keeps client secret secure!)
 */

/**
 * Redirect user to OIDC provider for authentication
 * Step 1: Call backend to get authorization URL (backend keeps client secret secure)
 * Step 2: Redirect user to that URL
 */
export async function redirectToOIDCProvider(tenantSlug: string = 'default'): Promise<void> {
  try {
    const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';
    
    // Call backend to generate authorization URL
    // Backend keeps client secret secure!
    const response = await fetch(`${API_BASE_URL}/auth/oidc/authorize?tenant=${encodeURIComponent(tenantSlug)}`);
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to generate authorization URL');
    }
    
    const { authorizationUrl } = await response.json();
    
    console.log('🔐 Redirecting to OIDC provider');
    
    // Redirect to provider
    window.location.href = authorizationUrl;
  } catch (error) {
    console.error('❌ Failed to redirect to OIDC provider:', error);
    throw error;
  }
}

/**
 * Handle token from backend redirect
 * Backend redirects to: /?token=xxx
 */
export function handleOIDCRedirect(): string | null {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const error = params.get('error');
  
  if (token) {
    console.log('✅ Received authentication token from backend');
    // Clean up URL
    window.history.replaceState({}, '', window.location.pathname);
    return token;
  }
  
  if (error) {
    console.error('❌ Authentication error:', error);
    return null;
  }
  
  return null;
}
